import { useParams } from "react-router-dom";
import { DisciplineForm } from "./components/DisciplineForm";
import { disciplineService } from "@/frontend/services";
import type { DisciplineResponseDTO } from "@/shared/dto";
import { useGetId } from "@/frontend/hooks/useGetId";
import { Spin } from "@/frontend/components/common";

export function UpdateDisciplinePage() {
  const { id } = useParams<{ id: string }>();
  const { data: disciplineData, loading: disciplineLoading } = useGetId<DisciplineResponseDTO>({
    fetchFn: disciplineService.getById,
    redirectUrl: "/disciplines",
    errorMessage: "Error al cargar la disciplina",
    id,
  });

  if (disciplineLoading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm w-full">
        <div className="flex justify-center items-center py-12">
          <Spin size="large" tip="Cargando..." />
        </div>
      </div>
    );
  }

  if (!disciplineData) {
    return null;
  }

  const initialValues = {
    name: disciplineData.name,
    description: disciplineData.description || "",
    color: disciplineData.color || "",
    sortOrder: disciplineData.sortOrder,
    isSystem: disciplineData.isSystem,
    canDelete: disciplineData.canDelete,
    canEdit: disciplineData.canEdit,
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm w-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Actualizar Disciplina</h2>
        <p className="text-gray-600 mt-1">
          Modifica la información de la disciplina en la plataforma
        </p>
      </div>
      <DisciplineForm disciplineId={id} initialValues={initialValues} />
    </div>
  );
}
